<template>
    <div class="card">
        <div class="card-body">
            <pagination-table
                :data="userAddresses"
                :propsToSearch="['id', USER_ADDRESSES.fields.address1, USER_ADDRESSES.fields.postalCode, USER_ADDRESSES.fields.city]"
                searchPlaceholder="Search id, address line 1, postal code, city"
                title="Addresses"
            >
                <template slot="table" slot-scope="scope">
                    <user-addresses-table :data="scope.data"></user-addresses-table>
                </template>
            </pagination-table>
        </div>
    </div>
</template>
<script>
import { USERS, USER_ADDRESSES } from 'db'
import PaginationTable from 'Shared/Tables/PaginationTable'
import UserAddressesTable from 'Shared/Tables/UserAddressesTable'
export default {
    components: {
        PaginationTable,
        UserAddressesTable
    },
    props: {
        userAddresses: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            USERS,
            USER_ADDRESSES
        }
    }
}
</script>
